module.exports = __webpack_public_path__ + "img/sliusar-ihor.35cb6ff5.jpg";